<template>
  <div>
    <!-- <el-tabs v-model="type" @tab-click="tabChange">
      <el-tab-pane label="未入账查询" name="notyet"></el-tab-pane>
      <el-tab-pane label="提现手续费汇总" name="feeSummary"></el-tab-pane>
      <el-tab-pane label="所有充提数据" name="total"></el-tab-pane>
    </el-tabs> -->
    <el-card>
      <el-date-picker
        v-model="dateVal"
        type="datetimerange"
        size="mini"
        class="search"
        start-placeholder="起始时间"
        end-placeholder="结束时间"
      ></el-date-picker>
      <el-input
        v-model="coinType" size="mini" class="search" placeholder="输入币种"></el-input>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="queryData(true)"
        circle
        size="mini"
      ></el-button>
      <el-table v-if="tableAble" :data="dwSummary">
        <el-table-column label="币种" prop="coinType"></el-table-column>
        <el-table-column label="手续费" prop="fee"></el-table-column>
        <el-table-column label="未入账" prop="noDepoAmount"></el-table-column>
        <el-table-column label="未下账" prop="downAmount"></el-table-column>
        <el-table-column label="充值总额" prop="depoTotalAmt"></el-table-column>
        <el-table-column label="提现总额" prop="withTotalAmt"></el-table-column>
        <el-table-column label="数额" prop="resultAmt"></el-table-column>
        <el-table-column label="时间">
          <template slot-scope="scope">
            {{ scope.row.createdTime | moment }}
          </template>
        </el-table-column>
      </el-table>
      <div class="pager-wrap">
        <pagination :size="pager.size" :page="pager.page" :total="dwSummaryTotal" @pageChanged="handlPageChanged"/>
      </div>
    </el-card>
  </div>
</template>
<script>
import "../store.js";
import { mapState, mapActions } from "vuex";
import Pagination from "components/pagination";
export default {
  name: "dataCenterDwSummary",
  data() {
    return {
      type: "total",
      coinType: "",
      dateVal: "",
      userId: "",
      pager: {
        page: 1,
        size: 10,
      },
    };
  },
  methods: {
    ...mapActions("dataCenter", [
      "getDwSummary",
      "tableAble"
    ]),
    queryData(refresh) {
      if (refresh) {
        this.pager.page = 1;
      }
      let q = {
        page: this.pager.page,
        size: this.pager.size,
      };
      if (this.dateVal) {
        q.startTime = this.dateVal[0].getTime();
        q.endTime = this.dateVal[1].getTime();
      }
      if (this.coinType) q.coinType = this.coinType;
      if (this.userId) q.userId = this.userId;
      this.getDwSummary(q);
    },
    tabChange() {
      this.queryData(true);
    },
    handlPageChanged(pagination) {
      this.pager.page = pagination.page;
      this.pager.size = pagination.size;
      this.queryData();
    },
  },
  computed: {
    ...mapState("dataCenter", [
      "dwSummary",
      "dwSummaryTotal"
    ]),
  },
  watch: {
  },
  mounted() {
    this.queryData();
  },
  components: {
    Pagination,
  },
};
</script>
<style scoped>
.search {
  width: 200px;
  margin: 0px 20px 20px 0px;
}
.date-search {
  margin-right: 20px;
}
</style>
